export default function FloatRank(){
	const rankBars = document.querySelectorAll('.float-rank');
	rankBars.forEach(function(el){
		const rank = parseFloat(el.dataset.rank) * 100;
		const point = el.querySelector('.point');
		point.style.marginLeft = rank + '%';
		// point.innerText = "Float: " + el.dataset.rank;
	})
}